import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import Navbar from '@/components/Navbar';
import MobileSidebar from '@/components/MobileSidebar';
import Footer from '@/components/Footer';
import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import WeddingPage from '@/pages/WeddingPage';
import FashionPage from '@/pages/FashionPage';
import EventsPage from '@/pages/EventsPage';
import CommercialPage from '@/pages/CommercialPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <ScrollToTop />
      <div className="noise-overlay min-h-screen bg-visyra-bg">
        <Navbar onMenuClick={() => setSidebarOpen(true)} />
        <MobileSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/wedding" element={<WeddingPage />} />
            <Route path="/fashion" element={<FashionPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/commercial" element={<CommercialPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
